import React, {useState, useEffect} from 'react';
import axios from '@app/lib/axios';

import * as Constant from '@app/Constant.js';
import Spinner from '../../../components/Spinner';

import AppVersionLogTable from './AppVersionLogTable.js';
import AppVersionLogTimeline from './AppVersionLogTimeline.js';

const AppVersionLog = ({appId, update_date, dataCallback}) => {
    const [dataLoaded, setDataLoaded] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [activeTab, setActiveTab] = useState('list');

    const callData = () => {
        setDataLoaded(false);
        if(appId) {
            axios({
              method: "get",
              url: Constant.API_DOMAIN+"/api/app_version/log/"+appId
            })
            .then(result => {
                const tableData = result.data.logList;
                setTableData(tableData);
                setDataLoaded(true);
              })
            .catch(error => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setTableData([]);
                setDataLoaded(true);
            });
        } else {
            setTableData([]);
            setDataLoaded(true);
        }
    }

    useEffect(() => {
        callData();
        return () => {};
    }, [appId, update_date]);


    if(!dataLoaded) {
        return (
            <div className="text-center p-3">
                <span className="dashboard-spinner spinner-xl"/>
            </div>
        )
    }
    
    return (
        <div className="influence-profile-content pills-regular">
            <ul className="nav nav-pills">
                <li className={`nav-item`}>
                    <a
                        className={`nav-link p-2 pr-3 pl-3 ${activeTab === 'list' ? ' active' : ' '}`}
                        href="#logTable"
                        onClick={(e)=>{
                            e.preventDefault();
                            setActiveTab('list');
                        }}
                    >
                        목록
                    </a>
                </li>
                <li className="nav-item">
                     <a
                        className={`nav-link p-2 pr-3 pl-3 ${activeTab === 'timeline' ? ' active' : ' '}`}
                        href="#logTable"
                        onClick={(e)=>{
                            e.preventDefault();
                            setActiveTab('timeline');
                        }}
                    >
                        타임라인
                    </a>
                </li>
            </ul>

            <div className="tab-content">
                <div className={`tab-pane ${activeTab === 'list' ? ' active' : ' '}`}>
                    <AppVersionLogTable
                        appId={appId}
                        list={tableData}
                        dataCallback={dataCallback}
                    />
                </div>
                <div className={`tab-pane ${activeTab === 'timeline' ? ' active' : ' '}`}>
                    <AppVersionLogTimeline
                        appId={appId}
                        list={tableData}
                        dataCallback={dataCallback}
                    />  
                </div>
            </div>
        </div>

    );
}

export default AppVersionLog;